<button mat-stroked-button id="darkMode" (click)="darkmode()"> Dark Mode </button>
<router-outlet></router-outlet>